// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-mdc-raised-button.mat-blue {
  background-color: #5479b9;
  color: white;
}

.mat-mdc-raised-button.mat-gray {
  background-color: #c7c7c7;
  color: white;
}

.mat-mdc-raised-button.mat-orange {
  background-color: #d49434;
  color: white;
}

.mat-mdc-raised-button.mat-green {
  background-color: #597550;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/document-upload/document-upload-button/document-upload-button.component.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,YAAA;AACF;;AACA;EACE,yBAAA;EACA,YAAA;AAEF;;AAAA;EACE,yBAAA;EACA,YAAA;AAGF;;AAAA;EACE,yBAAA;EACA,YAAA;AAGF","sourcesContent":[".mat-mdc-raised-button.mat-blue {\r\n  background-color: #5479b9;\r\n  color: white;\r\n}\r\n.mat-mdc-raised-button.mat-gray {\r\n  background-color: #c7c7c7;\r\n  color: white;\r\n}\r\n.mat-mdc-raised-button.mat-orange {\r\n  background-color: #d49434;\r\n  color: white;\r\n}\r\n\r\n.mat-mdc-raised-button.mat-green {\r\n  background-color: #597550;\r\n  color: white;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
